import MiniCard from './MiniCard'

export default MiniCard
